import { render, staticRenderFns } from "./cost_category.vue?vue&type=template&id=23201204&scoped=true&"
import script from "./cost_category.vue?vue&type=script&lang=js&"
export * from "./cost_category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23201204",
  null
  
)

export default component.exports